import Vue from 'vue'
import App from './App.vue'
import Notifications from 'vue-notification'
import VueGrecaptcha from 'vue-grecaptcha'

Vue.use(Notifications)
Vue.use(require('@websanova/vue-upload'));

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js